export default function DisconnectedBanner({ isCreator, onClose }) {
  return (
    <div className="flex items-center gap-3 px-4 py-3 rounded-xl bg-crimson-500/10 border border-crimson-500/30 animate-fade-in">
      <div className="w-2 h-2 rounded-full bg-crimson-400 animate-pulse flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-crimson-400 text-sm font-medium">Opponent disconnected</p>
        <p className="text-crimson-400/60 text-xs">
          {isCreator
            ? 'You can close the room or wait for them to reconnect.'
            : 'The host may have left. You can leave the room.'}
        </p>
      </div>
      <button onClick={onClose} className="btn-danger text-xs px-3 py-2 flex-shrink-0">
        {isCreator ? 'Close Room' : 'Leave'}
      </button>
    </div>
  )
}
